module.exports = __webpack_public_path__ + "img/CC1008.b748b6a2.png";